import styled from 'styled-components';

import { Flexbox } from '@components/web/src/foundations/Flexbox/Flexbox';
import { COLORS } from '@components/web/src/styles';

export const ProducerFeedbackModalContainer = styled(Flexbox)`
  border-radius: 16px;
  background-color: ${COLORS.base.white};
`;

export const RetailerLogo = styled.img`
  width: 250px;
  height: auto;
`;

export const CommentForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  align-items: center;
  gap: 16px;

  textarea::-webkit-scrollbar {
    width: 0;
  }
`;
